export default "__VITE_ASSET__D99Vmbvy__"